import React, {useState, useEffect, useCallback} from 'react';
import MainPageStyles from './MainPage.module.scss'
import {useAppDispatch, useAppSelector} from "../../utils";
import {API_URL_PHOTO} from "../../constants";
import {MembersType} from "../../entity/index.entity";
import {fetchContact} from "../../services/slices/ContactSlice";

const MemberCard = ({name, image, role}: MembersType) => (
    <div className={MainPageStyles.members}>
        <div className={MainPageStyles.border}>
            <div>
                <img
                    src={API_URL_PHOTO + image}
                    alt={name}
                    className={MainPageStyles.membersPhoto}
                />
            </div>
        </div>
        <p>{name}</p>
        <p className={MainPageStyles.role}>{role}</p>
    </div>
);

const MainPage = () => {
    const dispatch = useAppDispatch()
    const pageImages = useAppSelector((state) => state.contactSlice.pageImages);
    const members = useAppSelector((state) => state.contactSlice.members);

    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        dispatch(fetchContact());
    }, [dispatch]);

    const nextSlide = useCallback(() => {
        setActiveIndex((prevIndex) => (prevIndex + 1) % pageImages.length);
    }, [pageImages.length]);

    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 5000);

        return () => clearInterval(interval);
    }, [nextSlide]);

    return (
        <div>
            <div className={MainPageStyles.sliderWrapper}>
                <div className={MainPageStyles.slider}>
                    <div
                        className={MainPageStyles.sliderContent}
                        style={{
                            transform: `translateX(-${activeIndex * 100}%)`,
                            transition: 'transform 0.5s ease-in-out',
                        }}
                    >
                        {pageImages.map((image, index) => (
                            <div
                                key={index}
                                className={MainPageStyles.slide}
                            >
                                <img
                                    src={API_URL_PHOTO + image}
                                    alt={`Slide ${index}`}
                                    className={MainPageStyles.sliderImage}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className={MainPageStyles.wrapper}>
                <div className={MainPageStyles.mainTitleWrapper}>
                    <img src="/mainTitle.svg" alt="epatazhnost" className={MainPageStyles.mainTitle}/>
                </div>

                <div className={MainPageStyles.membersWrapper}>
                    <div className={MainPageStyles.row}>
                        {members.map((member, index) => (
                            <MemberCard key={index} {...member} />
                        ))}
                    </div>
                </div>
            </div>

        </div>
    );
};

export default MainPage;
